import { distanceBetweenCoordinates } from '~/lib/geoUtils'

export function useUserLocation() {
  const restaurantStore = useRestaurantStore()

  const userCoordinates = ref<
    | {
        lat: number
        lng: number
      }
    | undefined
  >()

  const isGeoEnabled = computed(() => restaurantStore.isGeoLocationActive)

  const distanceFromUser = (restaurantPosition: { lat: number; lng: number }) => {
    if (!userCoordinates.value) return 0
    return distanceBetweenCoordinates(
      userCoordinates.value.lat,
      userCoordinates.value.lng,
      restaurantPosition.lat,
      restaurantPosition.lng
    )
  }

  const updateUserLocation = async () => {
    if (isGeoEnabled.value) {
      const userLocation = await getUserLocation()
      userCoordinates.value = userLocation
    }
  }

  watch(isGeoEnabled, async () => {
    if (isGeoEnabled.value) {
      await updateUserLocation()
    } else {
      userCoordinates.value = undefined
    }
  })

  onMounted(async () => {
    await updateUserLocation()
  })

  return { isGeoEnabled, distanceFromUser, userCoordinates }
}
